import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { chakra } from "@chakra-ui/system";
import { cx, __DEV__ } from "@chakra-ui/utils";
import * as React from "react";
var fallbackIcon = {
  path: /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "inherit",
    cx: "12",
    cy: "18",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.89 9.05a3.975 3.975 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05",
    fill: "inherit"
  })),
  viewBox: "0 0 24 24"
};
var StyledSvg = chakra("svg", {
  themeKey: "Icon"
});
export var Icon = /*#__PURE__*/React.forwardRef(function Icon(props, ref) {
  var type = props.as,
      size = props.size,
      _props$boxSize = props.boxSize,
      boxSize = _props$boxSize === void 0 ? "1em" : _props$boxSize,
      viewBox = props.viewBox,
      _props$color = props.color,
      color = _props$color === void 0 ? "currentColor" : _props$color,
      _props$role = props.role,
      role = _props$role === void 0 ? "presentation" : _props$role,
      _props$focusable = props.focusable,
      focusable = _props$focusable === void 0 ? false : _props$focusable,
      children = props.children,
      className = props.className,
      rest = _objectWithoutPropertiesLoose(props, ["as", "size", "boxSize", "viewBox", "color", "role", "focusable", "children", "className"]);

  var _className = cx("chakra-icon", className);

  var sharedProps = {
    ref: ref,
    display: "inline-block",
    lineHeight: "1em",
    size: size,
    color: color,
    focusable: focusable,
    role: role,
    flexShrink: 0,
    boxSize: boxSize,
    className: _className
  };
  /**
   * If you're using an icon library like `react-icons`
   */

  if (type && typeof type !== "string") {
    return /*#__PURE__*/React.createElement(StyledSvg, _extends({
      as: type
    }, sharedProps, rest));
  }

  var _path = children != null ? children : fallbackIcon.path;

  var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;

  return /*#__PURE__*/React.createElement(StyledSvg, _extends({
    verticalAlign: "middle",
    viewBox: _viewBox
  }, sharedProps, rest), _path);
});

if (__DEV__) {
  Icon.displayName = "Icon";
}

export default Icon;